<!-- Colorbar at top -->
<lib-ds-colorbar></lib-ds-colorbar>

<!-- Main reset password container -->
<div class="ds-login-container" [class.has-background]="!!backgroundColor" [style.background-color]="backgroundColor">
  <div class="ds-login-content">
    <!-- Reset password form wrapper - card for staff, form-container for shelter -->
    <div [class.ds-login-card]="!!backgroundColor" [class.ds-login-form-container]="!backgroundColor">
      <!-- Reset password title -->
      <h1 class="ds-login-title">{{ title }}</h1>

      <!-- Reset password form -->
      <form [formGroup]="formResetEmail" (ngSubmit)="onSubmit()">
        <!-- Email field -->
        <lib-ds-form-field
          [label]="'Email'"
          [type]="'email'"
          id="reset-email"
          [placeholder]="'JohnDoe@example.com'"
          [autocomplete]="'email'"
          [required]="true"
          [hasError]="submitted && !!formResetEmail.controls['username'].errors"
          [errorMessage]="submitted && formResetEmail.controls['username'].errors?.['required'] ? 'Email is required.' : (submitted && formResetEmail.controls['username'].errors?.['email'] ? 'Please enter a valid email address.' : undefined)"
          formControlName="username"
          (inputChange)="clearEmailError()"
        ></lib-ds-form-field>

        <!-- Instructional text -->
        <p class="ds-reset-instruction-text">{{ instructionText }}</p>

        <!-- Error notice for network/server issues -->
        <lib-ds-notice
          *ngIf="(error$ | async)"
          [message]="(error$ | async) || ''"
          type="error"
          (dismiss)="onDismissError()"
        ></lib-ds-notice>

        <!-- Success notice -->
        <lib-ds-notice
          *ngIf="(resetPasswordSuccess$ | async)"
          message="Please check your email to reset your password."
          type="success"
          (dismiss)="onDismissSuccess()"
        ></lib-ds-notice>

        <!-- Submit button -->
        <button 
          type="submit" 
          class="ds-login-sign-in-button"
          [disabled]="isLoading$ | async"
          [attr.aria-busy]="isLoading$ | async">
          <lib-new-loading *ngIf="isLoading$ | async"></lib-new-loading>
          <span *ngIf="!(isLoading$ | async)">{{ buttonText }}</span>
        </button>
      </form>
    </div>

    <!-- Petszel logo (outside card for staff, inside form-container for shelter) -->
    <img [src]="logoSrc" alt="Petszel" class="ds-login-petszel-logo" />
  </div>
</div>

